import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import ModalHouseCommon from 'src/components/house/ModalHouseCommon'
import UserProfileCard from 'src/components/house/UserProfileCard'
import getMonthlyLikeRankings from 'src/services/get/getMonthlyLikeRankings'
import getUserInfo from 'src/services/get/getUserInfo'
import { HistoryRouteContext } from 'src/routes'
import { MAIN_PATHS } from 'src/routes/main'
import TitleRanking from 'src/assets/img/house/title_ranking.svg'
import ButtonRandom from 'src/assets/img/house/btn_random.svg'
import Ranking01 from 'src/assets/img/house/ranking_01.svg'
import Ranking02 from 'src/assets/img/house/ranking_02.svg'
import Ranking03 from 'src/assets/img/house/ranking_03.svg'
import { useAuthState } from 'src/providers/AuthProviders'

const ModalUserList = ({ open, onClose }) => {
  const { redirectTo } = useContext(HistoryRouteContext)
  const [rankingUsers, setRankingUsers] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingRandom, setIsLoadingRandom] = useState(false)
  const { user: currentUser } = useAuthState()

  useEffect(() => {
    const fetchRankings = async () => {
      if (!open) return

      setIsLoading(true)
      try {
        const data = await getMonthlyLikeRankings()
        const mappedUsers = data.map((item) => ({
          id: item.user_id,
          house_name: item.name || '',
          icon_url: item.icon_url || '',
          like_count: item.like_count || 0,
          ranking: item.rank
        }))
        setRankingUsers(mappedUsers)
      } catch (error) {
        setRankingUsers([])
      } finally {
        setIsLoading(false)
      }
    }

    fetchRankings()
  }, [open])

  const handleUserClick = (user) => {
    if (user?.id) {
      onClose()
      redirectTo(MAIN_PATHS.HousePageUser.replace(':userId', user.id))
    }
  }

  const handleRandomClick = async () => {
    setIsLoadingRandom(true)
    try {
      const randomUser = await getUserInfo(true)
      if (randomUser && randomUser.id) {
        onClose()
        redirectTo(MAIN_PATHS.HousePageUser.replace(':userId', randomUser.id))
      }
    } catch (error) {
    } finally {
      setIsLoadingRandom(false)
    }
  }
  return (
    <ModalHouseCommon
      open={open}
      onClose={onClose}
      height="max-h-[90%] max-w-[90%] xs:max-w-[350px]"
    >
      <div className="relative w-full flex flex-col overflow-auto hidden-scroll font-ShinMaruGo">
        <div className="sticky top-0 z-20 flex-shrink-0 flex w-full gap-2 border-b-[3px] rounded-tl-3xl border-house-pink bg-cream">
          <div className="max-w-1/3 py-2 rounded-tl-[16px] bg-house-pink bg-pat01">
            <span className="pl-4 pr-8 text-white text-xl tracking-wider font-semibold">
              お出かけ
            </span>
          </div>
        </div>

        <div className="bg-pat02 my-2">
          <div className="flex-shrink-0 mb-2 flex w-full justify-center">
            <img src={TitleRanking} alt="cancel" className="h-8" />
          </div>

          <div className="w-[95%] mx-auto bg-[#F1DCC3] bg-pat01 border-stone-gray border-2 rounded-xl">
            <div className="flex flex-col gap-5 pb-3 overflow-y-auto rounded-[10px]">
              <p className="text-center font-semibold text-[10px] xs:text-sm my-1 text-house-pink">
                タップでお友達のHOUSEを見に行こう！
              </p>
              {isLoading ? (
                <div className="text-center py-4 text-gray-600 text-sm">読み込み中...</div>
              ) : rankingUsers.length === 0 ? (
                <div className="text-center py-4 text-gray-600 text-sm">
                  ランキングデータがありません
                </div>
              ) : (
                rankingUsers.map((user, index) => {
                  const rankingImages = [Ranking01, Ranking02, Ranking03]
                  const showRankingBadge = index < 3
                  const disableClick = user.id === currentUser?.id
                  return (
                    <div key={user.id} className="relative px-2" style={{ pointerEvents: disableClick ? 'none' : 'auto' }}>
                      {showRankingBadge && (
                        <img
                          src={rankingImages[index]}
                          alt={`Ranking ${index + 1}`}
                          className="absolute left-2 top-1/2 -translate-y-1/2 z-10 h-12 xs:h-16"
                        />
                      )}
                      <UserProfileCard
                        user={user}
                        rank={user.ranking}
                        onProfileClick={() => handleUserClick(user)}
                        showEditButton={false}
                        isListUser={true}
                      />
                    </div>
                  )
                })
              )}
              <div className="flex items-center justify-center gap-2 px-2">
                <p className="w-[200px] font-medium text-sm tracking-wider text-[#062E3E]">
                  ランダム検索で色んなお友達の HOUSEも見に行っちゃおう！
                </p>
                <button
                  onClick={handleRandomClick}
                  className="cursor-pointer hover:opacity-80 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={isLoadingRandom}
                  style={{ pointerEvents: 'auto' }}
                >
                  <img
                    src={ButtonRandom}
                    alt="random"
                    style={{ pointerEvents: 'none' }}
                    className="h-10"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalHouseCommon>
  )
}

ModalUserList.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default ModalUserList
